module.exports = __webpack_public_path__ + "img/upgrade1.a577753b.png";